// Accept-invitation route (public): the emailed link carries the token in the #token= fragment, which the screen reads and strips.
import { createFileRoute } from "@tanstack/react-router";

import { AcceptInvitePage } from "@/features/auth/AcceptInvitePage";

export const Route = createFileRoute("/accept-invite")({
  component: AcceptInvitePage,
});
